import { render, staticRenderFns } from "./FrontAnon.vue?vue&type=template&id=56bf9c98&scoped=true"
import script from "./FrontAnon.vue?vue&type=script&lang=js"
export * from "./FrontAnon.vue?vue&type=script&lang=js"
import style0 from "./FrontAnon.vue?vue&type=style&index=0&id=56bf9c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf9c98",
  null
  
)

export default component.exports